import store from '../util/store'

export class Documentation {
  constructor(el) {
    if (el.documents) {
      this.isCustom = true
      this.el = el.el
      this.chevron = el.chevron
      this.cursorStick = el.cursorStick
      this.documents = el.documents
    } else {
      this.isCustom = false
      this.el = el
      this.chevron = el.querySelector('.c-documentation__chevron')
      this.cursorStick = el.querySelector('.c-documentation__cursor-stick')
      this.documents = Array.from(el.querySelectorAll('.c-documentation__document')).map((item) => ({
        el: item,
        header: item.querySelector('.c-documentation__document__header'),
        files: item.querySelector('.c-documentation__document__files')
      }))
    }

    this.init()
  }

  init() {
    this.documents.forEach(({header, el, files}) => {
      header.addEventListener('click', () => {
        this.chevron.classList.add('--visible')
        if (this.isCustom) {
          files.classList.add('--open')
        }

        el.classList.add('--open')

        this.el.addEventListener('wheel', (e) => e.stopPropagation())
      })

      files.addEventListener('mouseenter', () => {
        store.cursor.setStick(this.cursorStick)
        store.cursor.addState('-m')
        store.cursor.setIcon('resources--assets--images--svg--mouse')
      })

      files.addEventListener('mouseleave', () => {
        store.cursor.removeStick()
        store.cursor.removeState('-m')
        store.cursor.removeIcon()
      })
    })

    this.chevron.addEventListener('click', () => {
      this.documents.forEach(({el, files}) => {
        if (this.isCustom) {
          files.classList.remove('--open')
        }

        el.classList.remove('--open')
      })
      this.chevron.classList.remove('--visible')
      this.el.removeEventListener('wheel', (e) => e.stopPropagation())
    })
  }
}

export default function createDocumentation(config) {
  return new Documentation(config)
}
